import { queryStringService } from 'acerto-ds-services';
import storageService from './StorageService';

function getFromStorage(): Record<string, string> {
  return queryStringService.getAsObject(storageService.queryString.get());
}

function merge(): void {
  const mergedQuery = {
    ...getFromStorage(),
    ...queryStringService.getAsObject(),
  };

  const mergedQueryAsString = queryStringService.getAsString(mergedQuery);
  storageService.queryString.set(`?${mergedQueryAsString}`);
}

export default {
  getFromStorage,
  merge,
  ...queryStringService,
};
